<template>
  <v-row v-if="value.questionId > -1">
    <v-col
      cols="12"
      :md="shortApply ? 12 : 6"
      class="pb-0 d-flex"
      :class="align"
    >
      <label :for="questionIdentifier">
        {{ localize(question.questionLabel) }} *
      </label>
    </v-col>

    <v-col cols="12" :md="shortApply ? 12 : 6" class="mb-4 mb-md-0">
      <component
        v-model="question.value"
        :id="questionIdentifier"
        :question="question"
        :is="questionComponent"
      ></component>
    </v-col>
  </v-row>
</template>

<script>
import questionTypeEnums from '@/enum/question-type.js';

import languageQuestion from './langauge-question.vue';
import skillQuestion from './skill-question.vue';
import experienceQuestion from './experience-question.vue';
import textQuestion from './text-question.vue';
import yesNoQuestion from './yes-no-question.vue';

export default {
  props: {
    value: {
      type: Object,
      required: true
    },

    shortApply: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  computed: {
    align() {
      if (this.question.questionType !== this.questionType.Text) {
        return 'align-center';
      }

      return '';
    },

    question: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit('input', value);
      }
    },

    questionIdentifier() {
      return `question_item_${this.question.chapterIndex}_${this.question.sortIndex}`;
    },

    questionComponent() {
      if (this.question.questionType === this.questionType.Language) {
        return 'language-question';
      } else if (this.question.questionType === this.questionType.Competency) {
        return 'skill-question';
      } else if (this.question.questionType === this.questionType.Text) {
        return 'text-question';
      } else if (this.question.questionType === this.questionType.YesNo) {
        return 'yes-no-question';
      } else if (this.question.questionType === this.questionType.Experience) {
        return 'experience-question';
      }

      return '';
    },

    questionType() {
      return questionTypeEnums.QuestionType;
    }
  },

  components: {
    experienceQuestion,
    languageQuestion,
    skillQuestion,
    textQuestion,
    yesNoQuestion
  }
};
</script>
